// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loading_loader__3pmY_","load7":"Loading_load7__3Qimk"};